import { Injectable } from '@angular/core';
import { NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbTimeAdapterService extends NgbTimeAdapter<string> {

  fromModel(value: number | string | null): NgbTimeStruct | null {
    console.log('[TimeAdapter] fromModel called with:', value);

    if (!value) {
      return null;
    }

    if (typeof value === 'number') {
      return {
        hour: Math.floor(value / 60),
        minute: Math.round((value / 60 - Math.floor(value / 60)) * 60),
        second: 0
      }
    }

    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10)
    };
  }

  toModel(time: NgbTimeStruct | null): any {
    console.log('[TimeAdapter] fromModel called with:', time);

    return time != null ? (time.hour * 60 + time.minute) : null;
  }
}
